import React, { useEffect, useState } from "react";
import { axiosCarvenui } from "../../util/integration";
import Form from "../assets/Form";

import { useSelector } from "react-redux";
import en from "../../util/locales/en";
import ar from "../../util/locales/ar";

const WorkInfoForm = ({ next, back, showBackButton, data = {}, ...props }) => {
  const [formData, setFormData] = useState({
    ...data,
  });
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const language = useSelector((state) => state.language);
  const t = language === "en" ? en : ar;

  useEffect(() => {
    const getBanks = async () => {
      try {
        setLoading(true);
        const res = await axiosCarvenui.get(`/bank`);
        const data = res.data.results.map((bank) => {
          return {
            ...bank,
            value: bank.id,
            name_ar: bank.name_ar + " - " + bank.name,
          };
        });
        setBanks(data);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    getBanks();
  }, []);

  useEffect(() => {
    if (banks && banks.length > 0) {
      if (data.payrol_bank) {
        setFormData({ ...formData, payrol_bank: data.payrol_bank });
      }
    }
  }, [banks]);

  const workType_field = {
    name: "work_type",
    label: t.carFinance.workInfo.workType,
    displayName: t.carFinance.workInfo.workType,
    type: "select",
    options: [
      {
        name: "Retired",
        value: "retired",
        name_ar: "متقاعد",
      },
      {
        name: "Private",
        value: "private",
        name_ar: "موظف خاص",
      },
      {
        name: "Civil Governmental",
        value: "civil_governmental",
        name_ar: "موظف حكومي مدني",
      },
      {
        name: "Military Governmental",
        value: "military_governmental",
        name_ar: "موظف حكومي عسكري",
      },
      {
        name: "Semi-Governmental",
        value: "semi_governmental",
        name_ar: "موظف شبه حكومي",
      },
      {
        name: "Business Owner",
        value: "business_owner",
        name_ar: "صاحب عمل",
      },
      {
        name: "Aljazira Bank",
        value: "aljazira_bank",
        name_ar: "بنك الجزيرة",
      },
      {
        name: "Capital Employee",
        value: "capital_employee",
        name_ar: "موظف رأس المال",
      },
    ],
  };

  const workStartDate_field = {
    name: "work_duration",
    displayName: t.carFinance.workInfo.workDuration,
    label: t.carFinance.workInfo.workDuration,
    type: "date-picker",
    placeholder:
      language === "en" ? "Select work start date" : "اختر تاريخ بداية العمل",
    maxDate: new Date(), // Can't select future dates
    minDate: new Date(new Date().getFullYear() - 50, 0, 1), // Up to 50 years ago
  };

  const salary_field = {
    name: "salary",
    placeholder: t.carFinance.workInfo.salary,
    displayName: t.carFinance.workInfo.salary,
    displayCurrency: true,
    type: "number",
  };

  const bank_field = {
    name: "payrol_bank",
    label: t.carFinance.workInfo.payrollBank,
    displayName: t.carFinance.workInfo.payrollBank,
    type: "select",
    options: banks,
  };

  const fields = [
    workType_field,
    workStartDate_field,
    salary_field,
    bank_field,
  ];

  console.log("work info formData ==>: ",formData)

  return (
    <Form
      formData={formData}
      setFormData={setFormData}
      fields={fields}
      submitText={t.next}
      showBackButton={showBackButton}
      back={back}
      onSubmit={() => {
        next(formData);
      }}
    />
  );
};

export default WorkInfoForm;
